'use client';

import { useTranslation } from 'react-i18next';
import { BaseLayout } from 'structure/Layouts/SFILayouts/BaseLayout/BaseLayout';
import { MigrationPageContainer } from 'structure/migration/components/MigrationPageContainer/MigrationPageContainer';

export default function MigrationPage() {
  const { t } = useTranslation('migrate');

  return (
    <BaseLayout>
      <MigrationPageContainer title={t('MIGRATION_TITLE')} />
    </BaseLayout>
  );
}
